/* ### CONSTANTS ### */

import { IQueryMetaDataType } from '../../../../../boilerplate/redux/types/IQueryMetaDataType';
import { IApiErrorType } from '../../../../types/BaseTypes';
import { IShopGroupedByStateType } from '../../types/IShopGroupedByStateType';

export const SHOP_GROUPED_BY_STATE_FETCH_ENTRIES = '@BasePipeline/shopGroupedByStateReducer_FETCH_ENTRIES';
export const SHOP_GROUPED_BY_STATE_ADD_ENTRIES = '@BasePipeline/shopGroupedByStateReducer_ADD_ENTRIES';

export const SHOP_GROUPED_BY_STATE_SET_ERRORS   = '@BasePipeline/shopGroupedByStateReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function fetchShopGroupedByStates (queryKey: string) {
	return {
		type: SHOP_GROUPED_BY_STATE_FETCH_ENTRIES,
		queryKey,
	};
}

export function addShopGroupedByStateEntries (queryKey: string, entries: IShopGroupedByStateType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: SHOP_GROUPED_BY_STATE_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function setShopGroupedByStateErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: SHOP_GROUPED_BY_STATE_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
